import { getIsSubscriberActivated } from "../account";

export const getWizard = (state) => state.wizard;
export const getIsWizardProcessing = (state) =>
  getWizard(state).wizardProcessing;

export const getIsWizardComplete = (state) => {
  const isSubscriberActivated = getIsSubscriberActivated(state);
  const isWizardProcessing = getIsWizardProcessing(state);

  return isSubscriberActivated && !isWizardProcessing;
};
